import gql from 'graphql-tag'
import client from '@stores/apollo'

export default function checkIn({ id, checkedIn }: { id: string | undefined; checkedIn: boolean }) {
  return client.gql.mutate({
    mutation,
    variables: { input: { id, checkedIn: checkedIn } },
  })
}

const mutation = gql`
  mutation updateBooking($input: UpdateBookingInput!) {
    updateBooking(input: $input) {
      booking {
        id
        space {
          id
        }
        employee {
          id
        }
        startDate
        endDate
        checkedIn
        passedHealthCheck
      }
    }
  }
`
